import autoflow from './profiles/autoflow.js';
import bayhive from './profiles/bayhive.js';
import example from './profiles/example.js';
import { hexColor } from './contrast.js';

// Register trusted source files here; do not accept arbitrary server-supplied CSS.
export const brandProfiles = { autoflow, bayhive, example };
export const defaultThemes = { autoflow: 'autoflow', bayhive: 'bayhive' };

export function resolveBrandProfile(application, requested) {
  const context = application === 'bayhive' ? 'bayhive' : 'autoflow';
  const fallback = brandProfiles[defaultThemes[context]];
  if (fallback?.application !== context)
    throw new Error('Default theme must match its application');
  const candidate = Object.hasOwn(brandProfiles, requested) ? brandProfiles[requested] : null;
  const selected = candidate?.application === context ? candidate : fallback;
  if (!/^[a-z][a-z0-9-]*$/.test(selected.id)) throw new Error('Invalid brand profile id');
  if (typeof selected.productName !== 'string' || !selected.productName.trim())
    throw new Error('Brand productName is required');
  const base = brandProfiles[context];
  const profile = {
    ...base,
    ...selected,
    pdf: { ...base.pdf, ...selected.pdf },
    // Custom brands never accidentally inherit the base product's logo.
    logos: selected === base ? base.logos : selected.logos || {},
  };
  for (const field of [
    'text',
    'muted',
    'body',
    'border',
    'rowBorder',
    'header',
    'accent',
    'warningText',
  ]) {
    const value = profile.pdf[field];
    hexColor(typeof value === 'string' ? value : value?.fallback);
  }
  if (!['helvetica', 'times', 'courier'].includes(profile.pdf.font)) {
    throw new Error('PDF font must be helvetica, times, or courier');
  }
  const logo = profile.pdf.logo;
  if (
    logo &&
    (!/^data:image\/(png|jpeg);base64,/.test(logo.data) ||
      !['PNG', 'JPEG'].includes(logo.format) ||
      !Number.isFinite(logo.width) ||
      !Number.isFinite(logo.height) ||
      logo.width <= 0 ||
      logo.width > 200 ||
      logo.height <= 0 ||
      logo.height > 60)
  ) {
    throw new Error('PDF logo must be an embedded PNG/JPEG with dimensions up to 200 by 60 points');
  }
  return profile;
}
